// ABOUTME: Index route for /site-settings — redirects to /site-settings/connections.

import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/site-settings/")({
  component: () => <Navigate to="/site-settings/connections" />,
});
